import { LOCATION_CHANGE } from 'connected-react-router'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { filter, switchMap, catchError } from 'rxjs/operators'
import { fetchContext } from 'api/planet/context'
import { captureException } from 'helpers/raven'
import * as Actions from 'store/actions/index.ts'
import { getMemberLoggingIn, getLoggedIn, getURILocale, getURIPartner } from 'store/selectors'

const authenticationNotStarted = state =>
  !getMemberLoggingIn(state) && !getLoggedIn(state)

const contextEpic = (actions$, state$) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  filter(() => authenticationNotStarted(state$.value)),
  switchMap(() => {
    const locale = getURILocale(state$.value)
    const partner = getURIPartner(state$.value)

    return fetchContext(partner, locale).pipe(
      switchMap(({ response }) => of(
        Actions.context.onSetContext(response)
      )),
      catchError(error => {
        captureException(new Error('Unable to fetch Context'),
          { extra: { error } }
        )
        return of(Actions.context.onContextFetchError(error))
      })
    )
  })
)

export default contextEpic
